<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("pacom.masterAccount", 2) }}</label>
        <v-select
          label="username"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="masterAccountFilter"
          :options="masterAccounts"
          class="w-100"
          multiple
          :reduce="(val) => val.id"
          @input="(val) => $emit('update:masterAccountFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("tenants.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="tenantFilter"
          :options="tenants"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:tenantFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("centers.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="centerFilter"
          :options="centers"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:centerFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("sectors.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="sectorFilter"
          :options="sectors"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:sectorFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
  },
  props: {
    masterAccounts: {
      type: Array,
      default: [],
    },
    masterAccountFilter: {
      default: null
    },
    tenants: {
      type: Array,
      default: []
    },
    tenantFilter: {
      default: null
    },
    centers: {
      type: Array,
      default: []
    },
    centerFilter: {
      default: null
    },
    sectors: {
      type: Array,
      default: []
    },
    sectorFilter: {
      default: null
    }
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    }
  }
};
</script>
